import styled from 'styled-components';
import { motion } from 'framer-motion';
import { sizes } from 'style';
import { th } from 'style/theme';

export const OurStory = styled(motion.div)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  z-index: 2;
  margin-bottom: -1px;
`;

export const OurStoryText = styled(motion.div)`
  position: absolute;
  left: 20px;
  top: 23px;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;

  > svg {
    margin-top: 8px;
    margin-left: 20px;
    vertical-align: middle;
  }

  @media ${sizes.desktop} {
    left: 27%;
  }
`;

export const Wave = styled.svg`
  height: 100%;
  width: 100%;

  > path {
    fill: ${th('colors.black')};
    stroke: none;
  }
`;
